export const ADDRESS_FIELDS = `
  fragment AddressFields on Address {
    attn
    addressLine1
    addressLine2
    postalCode
  }
`
